import React from 'react';
import styled from 'styled-components';
import { Link } from "react-router-dom";





// 하단 모달창 공통소스 (내용 여러개)
export default function Modal_bt_inner(props) {

    

    return (
        // show 일때는 div(모달창)이 보여지고 아닐때는 null(안보임)
        props.show ?
        <div>
           <Modal_bg></Modal_bg>
            <Modal_txt_zone>
                <Modal_txt_2_list>
                {
                    props.data.map((value,index)=> { 
                        return  <Link key={`bottom-modal-two-btn-index-${index}`} to={value.path}>
                                    <Modal_txt_2>
                                        <Modal_txt_bt onClick={value.clickEvent} style={{color:value.color}}>{value.text}</Modal_txt_bt>
                                    </Modal_txt_2>
                                </Link>
                    })
                }   
                </Modal_txt_2_list>
                {
                    props.cancle ?
                    <Modal_txt><Modal_txt_bt onClick={()=>{props.setModalShow(false)}} style={{color:"#008aff"}}>{"취소"} </Modal_txt_bt></Modal_txt>
                    :
                    <Modal_txt><Modal_txt_bt style={{color:"red"}}>{"취소"}</Modal_txt_bt></Modal_txt>
                }
            </Modal_txt_zone>
        </div>
        :
        null
    )
}


const Modal_txt_zone = styled.div`
    position: fixed;
    bottom: 23px;
    // bottom: ${props=>props.bottom} ;
    left: 50%;
    transform: translateX(-50%);
    z-index: 500;
`
const Modal_txt = styled.p` 
    font-size: calc(100vw*(20/375));
    line-height: 1.2;
    letter-spacing: -0.48px;
    text-align: center;
    width:  calc(100vw*(346/375));
    height:  calc(100vw*(56/375));
    border-radius:  calc(100vw*(10/375));
    -webkit-backdrop-filter: blur( calc(100vw*(20/375)););
    backdrop-filter: blur( calc(100vw*(20/375)););
    background-color: #ffffff;
    margin-top:calc(100vw*(9/375));
`
const Modal_txt_2_list = styled.ul`
    border-radius:  calc(100vw*(10/375));
    overflow:hidden;
    & > a:last-child > li {
        border-bottom: none;
    }
`
const Modal_txt_2 = styled.li`
    border-bottom: calc(100vw*(1/375)) solid #d5d5d5; 
    font-size: calc(100vw*(20/375));
    line-height: 1.2;
    letter-spacing: -0.48px;
    text-align: center;
    width:  calc(100vw*(346/375));
    height:  calc(100vw*(56/375));
    
    -webkit-backdrop-filter: blur( calc(100vw*(20/375)););
    backdrop-filter: blur( calc(100vw*(20/375)););
    background-color: #ffffff;
`
const Modal_txt_bt = styled.button`
    width: 100%;
    height: 100%;
`
const Modal_bg = styled.div`
    position: fixed;
    top:0;
    left:0;
    width:100%;
    height:100%;
    background:rgba(0,0,0,0.6);
    z-index: 400;
`